
export type State =
  | { sample: string }

export type Action =
  | { action: "sample", text: string }

export const InitState: State = { sample: 'sample' };

export function Reducer(state: State, action: Action): State {
  switch (action.action) {
    case "sample": return Object.assign({}, state, { sample: action.text });
  }
  return state;
}
